module.exports = "/dist/roboto-latin-400.svg?3d3a53586bd78d1069ae4b89a3b9aa98";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-400.svg
// module id = 88
// module chunks = 0